<template>
	<Skeleton :loading="loading">
		<template #loading>
			<div id="restaurant_story">
				<div class="image-df-cover color-gray80" style="height: 300px;"	/>
					<div id="story">
					<div
						class="image-story color-gray95"
					/>
					<div class="text-xs-center pt--4 pb--2">
						<SkeletonItem variant="title" width="50%" />
					</div>
					<div class="text-xs-center">
						<SkeletonItem />
						<SkeletonItem />
						<SkeletonItem />
					</div>
				</div>
			</div>
		</template>

		<template>
			<div id="restaurant_story" v-if="restaurant">
				
				<img
					class="image-df-cover"
					v-if="restaurant.restaurantImage.length == 0"
					src="@/assets/icons/thank/default_cover.png"
				/>
				<el-image
					v-else
					class="image-cover"
					:src="(restaurant.restaurantImage[0].restaurant_image_key == 'restaurant/sample_restaurant_image.png') ? require('@/assets/icons/thank/default_cover.png') : 'https://images.foodstory.co/' + restaurant.restaurantImage[0].restaurant_image_key"
					fit="cover"
				/>
				<div id="story">
					<el-image
						class="image-story"
						:src="'https://images.foodstory.co/' + restaurant.logo"
						fit="cover"
					/>
					<h1 class="fs-wrp text-title">{{ restaurant.name }}</h1>
					<!-- <p class="story-describe">{{restaurant.story}}</p> -->
					<p 
						class="story-describe-hide text-heading3" 
						v-if="!readMoreActivated"
					>
						{{ restaurant.story }}
					</p>
					<p 
						v-else
						class="story-describe-more text-heading3" 
					>
						{{ restaurant.story }}
					</p>
					<a 
						class="color-black--text text-heading3" 
						v-if="!readMoreActivated && restaurant.story != '' && restaurant.story.length > 170" 
						@click="activateReadMore"
					>
						<i class="el-icon-arrow-down"/>
						{{ $t('pageRestaurant.more') }}
					</a>
					<a 
						class="color-warning--text text-heading3" 
						v-else-if="readMoreActivated && restaurant.story != '' && restaurant.story.length > 170" 
						@click="activateReadMore"
					>
						<i class="el-icon-arrow-up" /> 
						{{ $t('pageRestaurant.hide') }}
					</a>
				</div>
			</div>
		</template>
	</Skeleton>
</template>

<script>
export default {
	name: 'RestaurantStory',
	props:{
		restaurant: {	default: null },
		loading: { default: false }
	},
	data: function() {
		return {
			readMoreActivated: false
		}
	},
	methods: {
		activateReadMore () {
			this.readMoreActivated = !this.readMoreActivated
		}
	}
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/restaurant/RestaurantStory.vue